export default __webpack_public_path__ + "static/media/section-four.048a63dc1cadf77bfb75016b990bee69.svg";